import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const FRAGMENTS = {
  ITEM: '[data-fragment="tft.item"]',
  BODY: '[data-fragment="tft.body"]'
};


class TipForTrip extends WebComponent {
  constructor(props) {
    super(props);

    this.addActiveClass = this.addActiveClass.bind(this);
  }

  didMount() {
    this.on('click', FRAGMENTS.BODY, this.addActiveClass);
  }

  addActiveClass(e) {
    const {itemActiveClassName} = this.props;
    const eTargetItem = e.target.closest(FRAGMENTS.ITEM);
    const aHref = e.target.closest('a');
    const isActive = e.target.closest(`.${itemActiveClassName}`) != null;

    if (aHref && isActive) {return;}

    e.preventDefault();

    this.element.querySelectorAll(`.${itemActiveClassName}`).forEach((item) => {
      item.classList.remove(itemActiveClassName);
    });
    eTargetItem.classList.add(itemActiveClassName);
  }
}

TipForTrip.defaultProps = {
  itemActiveClassName: 'tip-for-trip__item--active'
};

export default TipForTrip;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/TipForTrip.js